// src/api/announcementApi.ts

import { config } from '../config';

export interface AnnouncementFormData {
  communicationGoal: string;
  mainTitle: string;
  keyMessage: string;
  keyContact?: string;
}

export interface UserInfo {
  userId: string;
  userName: string;
  userEmail: string;
}

export interface GenerateRequest {
  announcement: AnnouncementFormData;
  tone: string;
  channel?: string;
  user?: UserInfo;
}

export interface SourceDocument {
  title: string;
  url?: string;
}

export interface GenerationResult {
  content: string;
  sourcesUsed: SourceDocument[];
}

export const announcementApi = {
  async generate(request: GenerateRequest): Promise<GenerationResult> {
    const response = await fetch(`${config.apiBaseUrl}/generate`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'x-functions-key': config.functionKey,
      },
      body: JSON.stringify(request),
    });
    
    if (! response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    return response.json();
  },

  async submitForApproval(data: {
    originalText: string;
    generatedText: string;
    tone: string;
  }): Promise<void> {
    const response = await fetch(`${config.apiBaseUrl}/submit-for-approval`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify(data),
    });
    
    if (! response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
  },

  async exportToWord(content: string, title: string): Promise<Blob> {
    const response = await fetch(`${config.apiBaseUrl}/export/word`, {
      method: 'POST',
      headers:  { 'Content-Type': 'application/json' },
      body: JSON. stringify({ content, title }),
    });
    
    if (!response. ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    return response.blob();
  },

  async exportToPowerPoint(content: string, title: string): Promise<Blob> {
    const response = await fetch(`${config.apiBaseUrl}/export/powerpoint`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ content, title }),
    });
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    return response.blob();
  },

  async getIndexStats(): Promise<{
    total_documents: number;
    facets: Record<string, Record<string, number>>;
  }> {
    const response = await fetch(`${config.apiBaseUrl}/index-stats`);
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    return response.json();
  },

  async finalChecks(content: string): Promise<GenerationResult> {
    console.log(config.finalChecksFunctionKey);
    const response = await fetch(`${config.apiBaseUrl}/final_checks`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'x-functions-key': config.finalChecksFunctionKey,
      },
      body: JSON.stringify({ content }),
    });
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    return response.json();
  },
};